import { theme } from '../Theme';
import { css } from 'react-emotion';

export const eztradStyling = css`
  .items-container h2 {
    color: ${theme.colors.almostBlack};
    font-weight: 700;
  }
  ${theme.below.md} {
    .items-container {
      h2 {
        font-size: 1.375rem;
      }
    }
  }
`;
